import React, { useState, useRef } from 'react';

const products = [
  {
    id: 'wudhu-socks-black',
    name: 'Wudhu Socks - Black',
    fullName: 'The Wudhu Socks - Black',
    desc: 'One pair of The Wudhu Socks (Black).',
    originalPrice: '$27.99',
    price: '$21',
    image: '/images/the-wudhu-socks-5-pack.png',
  },
  {
    id: 'wudhu-socks-stone-gray',
    name: 'Wudhu Socks - Stone Gray',
    fullName: 'The Wudhu Socks - Stone Gray',
    desc: 'One pair of The Wudhu Socks (Stone Gray).',
    originalPrice: '$27.99',
    price: '$21',
    image: '/images/the-wudhu-socks-5-pack.png',
  },
  {
    id: 'wudhu-socks-navy-blue',
    name: 'Wudhu Socks - Navy Blue',
    fullName: 'The Wudhu Socks - Navy Blue',
    desc: 'One pair of The Wudhu Socks (Navy Blue).',
    originalPrice: '$27.99',
    price: '$21',
    image: '/images/the-wudhu-socks-5-pack.png',
  },
  {
    id: 'wudhu-socks-brown',
    name: 'Wudhu Socks - Brown',
    fullName: 'The Wudhu Socks - Brown',
    desc: 'One pair of The Wudhu Socks (Brown).',
    originalPrice: '$27.99',
    price: '$21',
    image: '/images/the-wudhu-socks-5-pack.png',
  },
  {
    id: 'wudhu-socks-ivory',
    name: 'Wudhu Socks - Ivory',
    fullName: 'The Wudhu Socks - Ivory',
    desc: 'One pair of The Wudhu Socks (Ivory).',
    originalPrice: '$27.99',
    price: '$21',
    image: '/images/the-wudhu-socks-5-pack.png',
  },
];

export default function Shop() {
  const [openAccordion, setOpenAccordion] = useState('wudhu-socks');
  const [selectedItem, setSelectedItem] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zip: '',
    message: '',
  });

  const formRef = useRef(null);

  const toggleAccordion = (id) => {
    setOpenAccordion(openAccordion === id ? null : id);
  };

  const handleSelectItem = (itemName) => {
    setSelectedItem(itemName);
    if (formRef.current) {
      formRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <main className="bg-gray-50 py-16">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Page Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900">Shop</h1>
          <p className="mt-4 text-lg text-gray-600">Browse available items below. Submit an inquiry to order.</p>
        </div>

        {/* Accordion Container */}
        <div className="space-y-4 mb-16">
          {/* Accordion Item 1: Wudhu Socks */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <button
              onClick={() => toggleAccordion('wudhu-socks')}
              className="w-full flex justify-between items-center p-5 text-left font-semibold text-lg text-gray-800 hover:bg-gray-50 focus:outline-none transition-colors"
            >
              <span>The Wudhu Socks - Socks to Wipe Over For Ablution</span>
              <svg
                className={`w-6 h-6 transform transition-transform duration-200 ${
                  openAccordion === 'wudhu-socks' ? 'rotate-180 text-indigo-600' : 'rotate-0 text-gray-500'
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            {openAccordion === 'wudhu-socks' && (
              <div className="p-6 border-t border-gray-200 bg-white">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                  {products.map((product) => (
                    <div
                      key={product.id}
                      className="bg-white rounded-lg border border-gray-200 overflow-hidden flex flex-col justify-between hover:shadow-md transition-shadow"
                    >
                      <img
                        src={product.image}
                        alt={product.fullName}
                        className="w-full h-48 object-cover bg-gray-50"
                      />
                      <div className="p-4 flex-1 flex flex-col justify-between">
                        <div>
                          <h3 className="text-lg font-bold text-gray-900 mb-1">{product.name}</h3>
                          <p className="text-gray-700 mb-2 text-sm">{product.desc}</p>
                          <p className="text-md font-semibold text-indigo-600 mb-3">
                            <s className="text-gray-400 font-normal mr-1">{product.originalPrice}</s>
                            {product.price}
                          </p>
                        </div>
                        <button
                          onClick={() => handleSelectItem(product.fullName)}
                          className="w-full bg-indigo-600 text-white font-semibold py-2 px-4 rounded-lg shadow-sm hover:bg-indigo-700 active:scale-95 transition-all text-sm"
                        >
                          Inquire to Order
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Accordion Item 2: Other Items */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <button
              onClick={() => toggleAccordion('other-items')}
              className="w-full flex justify-between items-center p-5 text-left font-semibold text-lg text-gray-800 hover:bg-gray-50 focus:outline-none transition-colors"
            >
              <span>Other Items</span>
              <svg
                className={`w-6 h-6 transform transition-transform duration-200 ${
                  openAccordion === 'other-items' ? 'rotate-180 text-indigo-600' : 'rotate-0 text-gray-500'
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            {openAccordion === 'other-items' && (
              <div className="p-6 border-t border-gray-200 bg-white">
                <p className="text-gray-600">More items coming soon!</p>
              </div>
            )}
          </div>
        </div>

        {/* Order Inquiry Form */}
        <div ref={formRef} id="order-form-section" className="max-w-xl mx-auto bg-white p-8 rounded-xl shadow-lg border border-gray-100">
          <h2 className="text-2xl font-semibold text-gray-900 mb-6 text-center">Order Inquiry</h2>
          <form action="https://formspree.io/f/xeopegpo" method="POST" className="space-y-4">
            <div>
              <label htmlFor="item" className="block text-sm font-medium text-gray-700 mb-1">
                Item Interested In:
              </label>
              <input
                type="text"
                name="item"
                id="item"
                value={selectedItem}
                onChange={(e) => setSelectedItem(e.target.value)}
                placeholder="Click an item above or type product name"
                required
                className="py-2 px-3 block w-full shadow-sm border border-gray-300 rounded-md bg-gray-50 focus:ring-indigo-500 focus:border-indigo-500 text-gray-800"
              />
            </div>

            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                Your Name:
              </label>
              <input
                type="text"
                name="name"
                id="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="py-2 px-3 block w-full shadow-sm border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 text-gray-800"
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                Your Email:
              </label>
              <input
                type="email"
                name="email"
                id="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="py-2 px-3 block w-full shadow-sm border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 text-gray-800"
              />
            </div>

            <div>
              <label htmlFor="addressLine1" className="block text-sm font-medium text-gray-700 mb-1">
                Street Address:
              </label>
              <input
                type="text"
                name="addressLine1"
                id="addressLine1"
                value={formData.addressLine1}
                onChange={handleChange}
                required
                autoComplete="street-address"
                className="py-2 px-3 block w-full shadow-sm border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 text-gray-800"
              />
            </div>

            <div>
              <label htmlFor="addressLine2" className="block text-sm font-medium text-gray-700 mb-1">
                Apartment, suite, etc. (Optional):
              </label>
              <input
                type="text"
                name="addressLine2"
                id="addressLine2"
                value={formData.addressLine2}
                onChange={handleChange}
                autoComplete="address-line2"
                className="py-2 px-3 block w-full shadow-sm border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 text-gray-800"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label htmlFor="city" className="block text-sm font-medium text-gray-700 mb-1">
                  City:
                </label>
                <input
                  type="text"
                  name="city"
                  id="city"
                  value={formData.city}
                  onChange={handleChange}
                  required
                  autoComplete="address-level2"
                  className="py-2 px-3 block w-full shadow-sm border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 text-gray-800"
                />
              </div>
              <div>
                <label htmlFor="state" className="block text-sm font-medium text-gray-700 mb-1">
                  State:
                </label>
                <input
                  type="text"
                  name="state"
                  id="state"
                  value={formData.state}
                  onChange={handleChange}
                  required
                  autoComplete="address-level1"
                  className="py-2 px-3 block w-full shadow-sm border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 text-gray-800"
                />
              </div>
              <div>
                <label htmlFor="zip" className="block text-sm font-medium text-gray-700 mb-1">
                  ZIP / Postal:
                </label>
                <input
                  type="text"
                  name="zip"
                  id="zip"
                  value={formData.zip}
                  onChange={handleChange}
                  required
                  autoComplete="postal-code"
                  className="py-2 px-3 block w-full shadow-sm border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 text-gray-800"
                />
              </div>
            </div>

            <div>
              <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                Message (Optional):
              </label>
              <textarea
                name="message"
                id="message"
                rows="3"
                value={formData.message}
                onChange={handleChange}
                className="py-2 px-3 block w-full shadow-sm border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 text-gray-800"
              />
            </div>

            <button
              type="submit"
              className="w-full bg-green-600 text-white font-semibold py-3 px-6 rounded-lg shadow-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all active:scale-[0.99]"
            >
              Submit Inquiry
            </button>
          </form>
        </div>
      </div>
    </main>
  );
}
